import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar/Navbar';
import Bredcom from '../components/Bredcom/Bredcom';
import Footer from '../components/Footer/Footer';
import Galerija from '../components/Galerija/Galerija';

function GalerijaPage () {
    const { i18n } = useTranslation();
    const isEnglish = i18n.language?.startsWith('en');

    return (
        <>
        <Navbar/>
        <Bredcom title={isEnglish ? "Home" : "Početna"} subtitle={isEnglish ? "Gallery" : "Galerija"} />
        <Galerija />
        <Footer />
        </>
    )
}
export default GalerijaPage;